<template>
  <footer class="footer">
    <div class="container copyright text-center">
              Copyright &copy; {{ new Date().getFullYear() }} 
              原來是洋蔥股份有限公司 <br/>
              Itsonion Co., Ltd. All Rights Reserved.<br />
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
